import React from "react"

interface IComponentProps {
    onClick: (ev: any) => void
}

export default class AddToRecordingIcon extends React.Component<IComponentProps, {}> {
    render() {
        return (
            <div className={"AddToRecordingIcon"}>
                <div className={"AddToRecordingIcon__icon"} onClick={this.props.onClick} tabIndex={0}
                onKeyPress={this.props.onClick}
                />
            </div>
        )
    }
}
